import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DocumentUploadComponent } from './document-upload.component'

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        DocumentUploadComponent,
    ],
    exports: [
        DocumentUploadComponent,
    ],
})
export class DocumentUploadModule {
}